import CustomerFeeback from "./CustomerFeeback";
import Review from "./Review";
import { Link } from "react-router-dom";
import Button from "../../../components/shared/Button";

const Feedback = () => {
  
  return (
    <div className="my-10 sm:p-5 p-2 space-y-5">
      <CustomerFeeback />
      <Review />
      <p className="font-[Mulish] text-sm w-[80%] mx-auto text-center">
        Join thousands of students across 10+ countries and experience the best
        in Quranic education!
      </p>
      <p className="font-[Mulish]  w-[80%] mx-auto text-center">
        {" "}
        Ready to start your journey?
      </p>
      <Link
        className=" w-full flex justify-center"
        to={"https://forms.gle/wDeTHHiRad5U4PaY6"}
      >
        <Button
          btnBgColor={
            "bg-[#004C97]  hover:bg-white hover:text-[#3b76db] hover:rounded-full "
          }
          padding={"px-5 py-3 sm:rounded-full"}
          btnColor={"transition-all ease-in-out text-white shadow"}
          btnText={"Enroll Now"}
        />
      </Link>
    </div>
  );
};

export default Feedback;
